/**
 * @generated SignedSource<<9b0f4fd2c66e1d8c6a203220a8aab172>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LogOutMutationInput = {
  clientMutationId?: string | null;
};
export type onLogoutMutation$variables = {
  input: LogOutMutationInput;
};
export type onLogoutMutation$data = {
  readonly logOut: {
    readonly success: boolean;
  };
};
export type onLogoutMutation = {
  response: onLogoutMutation$data;
  variables: onLogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "onLogoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LogOutMutationPayload",
        "kind": "LinkedField",
        "name": "logOut",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onLogoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LogOutMutationPayload",
        "kind": "LinkedField",
        "name": "logOut",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d7ac3c5537d5453bb7e56c051f8a5d4",
    "id": null,
    "metadata": {},
    "name": "onLogoutMutation",
    "operationKind": "mutation",
    "text": "mutation onLogoutMutation(\n  $input: LogOutMutationInput!\n) {\n  logOut(input: $input) {\n    success\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "51144d72bb757f9f5e8cf6398eda16f2";

export default node;
